import classNames from "classnames";
import React, {
    HTMLAttributes,
    ReactNode,
} from "react";
import useTableData, { ContainsId, Events } from "../base";
import Styles from "../Table.module.scss";
import Button, { Type as ButtonType } from "./Button";
import Control from "./Control";
import CreateControl from "./Create";
import Filter, { Type as FilterType } from "./Filter";
import Filters from "./Filters";
import SearchControl, { Type as SearchControlType } from "./Search";
import Seperator from "./Seperator";
import SortBy from "./SortBy";
import RowCount from "./RowCount";

export interface TableControlsProps extends HTMLAttributes<HTMLTableElement> {
    children?: ReactNode;
}

const TableControls = React.forwardRef((
    args: TableControlsProps,
    ref: React.ForwardedRef<HTMLTableElement>,
): ReactNode => {
    const {
        children,
        className,
        ...rest
    } = args;

    const data = useTableData();
    data.events.useEvent(Events.UPDATED_EMPTY_VIEW);
    if (data.isEmptyData && data.emptyElement) {
        return null;
    }

    return (
        <div className={classNames(Styles.controls, className)} ref={ref} {...rest}>
            {children}
        </div>
    );
});

TableControls.defaultProps = {

};

type TableControlsType = (
    props: TableControlsProps & { ref?: React.ForwardedRef<HTMLDivElement> }
) => ReactNode;

export type TableControlsWithTypes<T extends ContainsId> = TableControlsType & {
    Search: SearchControlType<T>;
    Create: typeof CreateControl;
    SortBy: typeof SortBy;
    Seperator: typeof Seperator;
    Control: typeof Control;
    Filter: FilterType<T>;
    Filters: typeof Filters;
    Button: ButtonType;
    RowCount: typeof RowCount
}

const TableControlContainer = TableControls as unknown as TableControlsWithTypes<ContainsId>;
TableControlContainer.Search = SearchControl;
TableControlContainer.Create = CreateControl;
TableControlContainer.Button = Button;
TableControlContainer.SortBy = SortBy;
TableControlContainer.Seperator = Seperator;
TableControlContainer.Control = Control;
TableControlContainer.Filter = Filter;
TableControlContainer.Filters = Filters;
TableControlContainer.RowCount = RowCount;

export default TableControlContainer;
